var exports = {
  "B": "Sidebar__IYCbTT",
};

module.exports = exports;
